import gql from 'graphql-tag';
import moment from 'moment-timezone';

const getOrgTotalEngagementsQuery = gql`
  query GetOrgTotalEngagements(
    $createdAt: [String], 
    $organisationId: String!,
    $productShortName: String!, 
    $timezone: String!
  ) {
    getOrgTotalEngagements(
      createdAt: $createdAt,
      organisationId: $organisationId,
      productShortName: $productShortName,
      timezone: $timezone
    ) {
      stats
    }
  }
`;

const queryGetOrgTotalEngagements = (organisationId) => ({
  query: getOrgTotalEngagementsQuery,
  module: 'analytics',
  buildVariables: (data) => {
    const {
      createdAt,
      productShortName,
      timezone = moment.tz.guess()
    } = data;
    return {
      createdAt,
      organisationId,
      productShortName,
      timezone
    };
  }
});

export default queryGetOrgTotalEngagements;